"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.5.1'] && _();
}
catch (e) { }
